import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: transparent;
`;

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

export const AddButton = styled.button`
  background: #2563eb;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #1d4ed8;
  }
`;

export const LayoutGrid = styled.div`
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 24px;
  align-items: start;
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const RightColumn = styled.div`
  // background: white;
  border-radius: 12px;
  // padding: 24px;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  // border: 1px solid #e5e7eb;
`;

export const Card = styled.div`
  background: white;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 16px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05);
`;

export const JournalList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const JournalItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  transition: background 0.2s;
  cursor: pointer;

  &:hover {
    background: #f9fafb;
  }
`;

export const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.bgColor || "#f3f4f6"};
  color: ${(props) => props.color || "#6b7280"};
  font-size: 20px;
`;

export const JournalText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const JournalTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #111827;
`;

export const JournalSubtitle = styled.span`
  font-size: 12px;
  color: #6b7280;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  color: #6b7280;
  gap: 16px;

  img {
    max-width: 200px;
    margin-bottom: 8px;
  }

  h3 {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    margin: 0;
  }

  p {
    font-size: 14px;
    margin: 0;
  }
`;

export const ActionLink = styled.button`
  background: none;
  border: none;
  color: #2563eb;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;

  &:hover {
    color: #1d4ed8;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  width: 550px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04);
`;

export const ModalHeader = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }

  button {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #9ca3af;
  }
`;

export const ModalBody = styled.div`
  padding: 20px;
`;

export const ModalFooter = styled.div`
  padding: 16px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const TabList = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 24px;
  border-bottom: 1px solid #f3f4f6;
  padding-bottom: 12px;
`;

export const TabItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  color: ${(props) => (props.active ? "#2563eb" : "#9ca3af")};
  transition: all 0.2s;
  flex: 1;
  padding: 8px 4px;
  border-radius: 8px;
  background: ${(props) => (props.active ? "#eff6ff" : "transparent")};

  &:hover {
    color: ${(props) => (props.active ? "#2563eb" : "#6b7280")};
    background: ${(props) => (props.active ? "#eff6ff" : "#f9fafb")};
  }

  svg {
    font-size: 20px;
  }

  span {
    font-size: 11px;
    text-align: center;
    line-height: 1.2;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;

  label {
    font-size: 14px;
    font-weight: 500;
    color: #374151;
  }

  input, textarea {
    padding: 10px 12px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    outline: none;

    &:focus {
      border-color: #2563eb;
      box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
    }
  }

  textarea {
    resize: vertical;
    min-height: 80px;
  }
`;

export const SecondaryButton = styled.button`
  background: white;
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #f9fafb;
  }
`;

export const EntryCard = styled(Card)`
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
  margin-bottom: 16px;
  border: 1px solid #e5e7eb;
`;

export const EntryCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: #fff;
  border-bottom: 1px solid #f3f4f6;

  h4 {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: #111827;
  }
`;

export const Badge = styled.span`
  background: ${(props) => (props.status?.toLowerCase() === "reviewed" ? "#def7ec" : "#fef3c7")};
  color: ${(props) => (props.status?.toLowerCase() === "reviewed" ? "#03543f" : "#92400e")};
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 6px;
  margin-right: 12px;
`;

export const ActionIcons = styled.div`
  display: flex;
  gap: 16px;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};

  svg {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    font-size: 20px;
    stroke-width: 2.5;
    transition: transform 0.2s, opacity 0.2s;

    &:hover {
      transform: scale(1.1);
    }

    &.edit {
      color: #3b82f6;
    }
    
    &.delete {
      color: #ef4444;
    }
  }
`;

export const EntryBody = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  padding: 20px;
`;

export const DataItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const DataLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  .label {
    font-size: 12px;
    color: #6b7280;
    font-weight: 500;
  }

  .value {
    font-size: 13px;
    color: #111827;
    font-weight: 500;
    word-break: break-word;
  }
`;

export const NestedSection = styled.div`
  background: #f9fafb;
  border-top: 1px solid #f3f4f6;
  padding: 16px 20px;
  &:last-child {
    border-radius: 0 0 12px 12px;
  }
`;

export const SectionHeader = styled.h5`
  color: #2563eb;
  font-size: 13px;
  font-weight: 600;
  margin: 0 0 12px 0;
  letter-spacing: 0.025em;
`;

export const NestedItem = styled.div`
  margin-bottom: 12px;
  &:last-child { margin-bottom: 0; }
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
  &:last-child { border-bottom: none; }
`;

export const NestedText = styled.p`
  font-size: 14px;
  color: #374151;
  margin: 0 0 4px 0;
  font-weight: 500;
`;

export const NestedSubtext = styled.span`
  font-size: 12px;
  color: #6b7280;
`;

export const RecommendationTitle = styled.h6`
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 4px 0;
`;

export const PrimaryButton = styled(AddButton)`
  padding: 8px 16px;
`;

